import React from 'react'
import { observer } from 'mobx-react'

import FormDatePicker, { FormDatePickerProps } from '../../FormDatePicker'

const DatePicker = <T extends {}>(props: FormDatePickerProps<T>) => {
	return <FormDatePicker size="large" autoFocus {...props} />
}

export default observer(DatePicker)
